import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/vehicles_/$vehicleId/')({
  // No own page: /vehicles/$vehicleId always lands on the FIRST wizard step (Identity) — the list's
  // profile drawer / row Edit navigate here and must start the stepper at step 1.
  beforeLoad: ({ params }): void => {
    throw redirect({ params: { vehicleId: params.vehicleId }, to: '/vehicles/$vehicleId/identity' });
  },
});
